import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { EditTeeTimeSettingsPage } from './edit-teetime-settings';
import { EditTeeTimeSettingsPageRoutingModule } from './edit-teetime-settings-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    EditTeeTimeSettingsPageRoutingModule
  ],
  declarations: [EditTeeTimeSettingsPage]
})
export class EditTeeTimeSettingsPageModule {}
